// core
import React from 'react';

import * as xmlbuilder from 'xmlbuilder2';

// apollo
import { useQuery } from '@apollo/client';
import query from './graphql/SitemapQuery.graphql';

// material
import Typography from '@material-ui/core/Typography';
import { SitemapQuery } from './graphql/SitemapQuery';

export const Sitemap = () => {
  const { data, error, loading } = useQuery<SitemapQuery>(query);

  if (error) {
    console.log(error);
    global.bugsnagClient.notify(error);
  }

  return loading ? null : error ? (
    <Typography variant="caption" color="error">
      Chyba v spojení so serverom. Skúste to prosím znova.
    </Typography>
  ) : (
    <>{generateSitemap(data?.categories || [], data?.cars.edges || [])}</>
  );
};

/**
 * Generates sitemap.xml feed
 */
const generateSitemap = (
  categories: SitemapQuery['categories'],
  cars: SitemapQuery['cars']['edges']
) => {
  const baseUrl = 'https://www.edenbazar.sk';
  const cdnUrl = 'https://cdn.edenbazar.sk';

  const sitemap = xmlbuilder
    .create()
    .ele('urlset', { encoding: 'UTF-8' })
    .att('xmlns', 'http://www.sitemaps.org/schemas/sitemap/0.9')
    .att('xmlns:image', 'http://www.google.com/schemas/sitemap-image/1.1');

  // static sites
  sitemap.ele({ url: { loc: baseUrl + '/' } });
  sitemap.ele({ url: { loc: baseUrl + '/o-nas' } });
  sitemap.ele({ url: { loc: baseUrl + '/financovanie' } });
  // sitemap.ele({ url: { loc: baseURL + '/online-predaj-vozidiel' } });
  sitemap.ele({ url: { loc: baseUrl + '/kontakt' } });
  // sitemap.ele({ url: { loc: baseURL + '/super-soco' } });
  sitemap.ele({ url: { loc: baseUrl + '/vozidla-na-predaj' } });

  // categories
  categories?.forEach((category) => {
    sitemap.ele({ url: { loc: baseUrl + `/vozidla-na-predaj/${category.slug}` } });
  });

  cars.forEach((car) => {
    const category = car.mainCategory.slug;

    const c = sitemap.ele({
      url: {
        loc: baseUrl + `/vozidla-na-predaj/${category}/${car.slug}`,
        lastmod: car.updatedAt,
        changefreq: car.sold ? 'never' : undefined
      }
    });

    if (car.authenticityReport) {
      sitemap.ele({
        url: {
          loc: cdnUrl + `/subor/${car.authenticityReport}`,
          changefreq: car.sold ? 'never' : undefined
        }
      });
    }

    car.imagesBanners?.forEach((image) =>
      c.ele('image:image').ele('image:loc').txt(`${cdnUrl}/fotografia/${image}`)
    );
  });

  return sitemap.end();
};
